import type { AwaitingEntity } from "../types";
import "./PanelAwaiting.css";

function fmtWait(min: number): string {
  if (min < 60) return `${min}m`;
  if (min < 24 * 60) {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return m === 0 ? `${h}h` : `${h}h ${m}m`;
  }
  const d = Math.floor(min / (24 * 60));
  const h = Math.floor((min % (24 * 60)) / 60);
  return h === 0 ? `${d}d` : `${d}d ${h}h`;
}

export default function PanelAwaiting({
  awaiting,
}: {
  awaiting: AwaitingEntity[];
}) {
  return (
    <section
      className={`panel panel-awaiting ${awaiting.length === 0 ? "is-empty" : "is-populated"}`}
      aria-labelledby="panel-awaiting-title"
    >
      <header className="panel-head">
        <h2 className="panel-title" id="panel-awaiting-title">
          Awaiting
        </h2>
        <span className="panel-meta">
          <span className="panel-count">{awaiting.length}</span>
          <span className="panel-sub">
            entities idle / waiting / stuck · polled every 15s
          </span>
        </span>
      </header>
      <div className="panel-body">
        {awaiting.length === 0 && (
          <div className="panel-empty">No entities awaiting.</div>
        )}
        {awaiting.map((a) => (
          <div
            key={a.entity_id}
            className={`awaiting-row${a.stuck ? " awaiting-row-stuck" : ""}`}
          >
            <span className="awaiting-id">{a.entity_id}</span>
            <span className="awaiting-state-cell">
              <span
                className={`awaiting-state awaiting-state-${a.presence_state}`}
                title={`presence_state=${a.presence_state}`}
              >
                {a.presence_state}
              </span>
              {a.stuck && (
                <span
                  className="awaiting-stuck-badge"
                  title="presence_state=working but last_change_at >30min stale — likely hung session"
                >
                  STUCK
                </span>
              )}
            </span>
            <span className="awaiting-session" title={`session ${a.session_id}`}>
              {a.session_id}
            </span>
            <span className="awaiting-time" title={`since ${a.last_change_at}`}>
              {fmtWait(a.time_waiting_min)}
            </span>
            <span className="awaiting-activity" title={a.last_activity}>
              {a.last_activity}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
